import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useFormik } from "formik";
import "./MVOC.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import InputLayout from "../../../components/uikit/components/inputLayout/InputLayout";
import { clarityNav } from "../../../services/api/clarityNav/apiService";
import { MVOCFORM } from "../../../constants/projectDetailForm";
import {
  CHUNK_SIZE,
  ERROR_MESSAGES,
  INSIGHT_type,
  SNACKBAR_TYPES,
  checkDataisObject,
  createProjectHeading,
  getRouteId,
  uploadfileComponentDetails,
} from "../../../constants/constant";
import ButtonComponent from "../../../components/uikit/components/Button/ButtonComponent";
import {
  setCurrentMVOCDetail,
  setStepcompleted,
  updateFormValues,
} from "../../../features/product/projectSlice";
import SelectDropdown from "../../../components/uikit/components/SelectDropdown/SelectDropdown";
import MvocSampleFile from "../../../assets/download/sample_mvoc.xlsx";
import SiMappingSampleFile from "../../../assets/download/sample_si_mapping.xlsx";
import * as XLSX from "xlsx";
// import { uploadFileServiceApi } from "../../../services/axios";
import UploadIcon from "../../../assets/images/UploadIcon.svg";
import Ristricticon from "../../../assets/images/restricticon.svg";
import Downloadicon from "../../../assets/images/download-icon.svg";
import {
  closeSnackbar,
  openSnackbar,
} from "../../../features/snackbar/snackbarslice";
import fileicon from "../../../assets/images/File icon.svg";
import closeicon from "../../../assets/images/closered.svg";
import FileUploadModal from "../../../components/uikit/components/modals/FileUpload/FileUploadModal";
import {
  setAttachmentRows,
  setCurrentMVOCMetaData,
} from "../../../features/MVOC/mvocSlice";
import ApiLoader from "../../../components/MvocPrimary/ApiLoader";
import { listenToServerEvents } from "../../../constants/ServerEvent";
import AddFile from "../AddFile/AddFile";
import {
  createValidationSchema,
  transformMvocMetaData,
} from "./AttachmentMapper";
import {
  startLoading,
  stopLoading,
} from "../../../features/loader/loaderSlice";
import PromptModal from "../../../components/uikit/components/modals/PromptModal/PromptModal";
import ArrowRight from "../../../assets/images/ArrowRight.svg";
import {
  closePromptModal,
  openPromptModal,
  setRefreshPrompts,
} from "../../../features/Modal/ModalSlice";

function MVOC({ projectexist, disableMVOC }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const project_id = getRouteId(location.pathname);
  const [wave_unified_id, setWave_unified_id] = useState(null);
  const [attachmentUUID, setAttachmentUUID] = useState(null);
  const [disableInput, setDisableInput] = useState(false);
  const [projectNameExistErrMsg, setProjectNameExistErrMsg] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [mvocFileId, setMvocFileId] = useState(null);
  const [fileError, setFileError] = useState("");
  const [isAddFiles, setIsAddFiles] = useState(false);
  // Hide icon of upload, when user upload file
  const [hideDragDropOfMvoc, setHideDragDropOfMvoc] = useState(false);
  const [hideDragDropOfSi, setHideDragDropOfSi] = useState(false);
  // SI Mapping file upload and Validation
  const [siMappingSelectedFile, setSiMappingSelectedFile] = useState(null);
  const [siMappingFileId, setSiMappingFileId] = useState(null);
  const [siMappingFileError, setSiMappingFileError] = useState("");
  const [openModal, setopenModal] = useState(false);
  const [progress, setProgress] = useState(0);
  const [rawErrorMessage, setRawErrorMessage] = useState("");
  const [dataErrorMessage, setDataErrorMessage] = useState("");
  const [upladedSuccess, setUploadedSuccess] = useState("pending");
  const [isFileUploadSuccessful, setIsFileUploadSuccessful] = useState(false);
  const [isFileSiUpload, setIsFileSiUpload] = useState(false);
  const [duplicateErrorMessage, setDuplicateErrorMessage] = useState("");
  const [isActive, setIsActive] = useState(true);
  const currentMVOCDetail = useSelector(
    (state) => state?.product?.currentMVOCDetail
  );
  const currentProjectDetails = useSelector(
    (state) => state?.product?.currentProjectDetail
  );
  const AttachmentsRows = useSelector(
    (state) => state?.mvocSlice?.attachmentRows
  );
  const upFields = MVOCFORM.filter((field) => field.section === "up") || [];
  const downFields = MVOCFORM.filter((field) => field.section === "down") || [];
  const stepper = useSelector((state) => state?.product?.stepCompleted);
  const userId = useSelector(
    (state) => state?.currentUserDetail?.user_id
  );
  const { open } = useSelector((state) => state?.ModalSlice);
  // function to create project
  const [createMVOC] = clarityNav.useCreateMVOCMutation();
  const [nameValidation] = clarityNav.useProjectNameValidationMutation();
  const [saveWaveAndPromptAPI] = clarityNav.useSaveWaveAndPromptMutation();
  const [fetchChatGptProcessService] = clarityNav.useFetchChatGptMutation();
  const [acknowledgeAPI] = clarityNav.useAcknowlegeChatGptMutation();
  const [cancleFileUpload] = clarityNav.useFileInactiveMutation();
  const [uploadFileServiceApi] = clarityNav.useUploadFileServiceApiMutation();
  // // Fetching the project prompts from the API
  const [projectPrompts] = clarityNav.useProjectPromptsMutation();
  //fetch MVOC data by project id
  const [fetchMvocDataById] =
    clarityNav.endpoints.getMvocDataFromProjectId.useLazyQuery();
  // Define state for API loading state to check api is complete or not
  const [apiLoading, setApiLoading] = useState(false);
  const [apiLoaderInfo, setaApiLoaderInfo] = useState(false);
  // Define state for chatGPT API loading, is comeplete or false
  const [oopsLoader, setOopsLoader] = useState(false);
  const [eventResponse, setEventResponse] = useState(false);
  const [promptLookup, setPromptLookup] = useState([]);
  const [isPromptFetched, setIsPromptFetched] = useState(false);
  const wave_lookup = useSelector(
    (state) => state?.lookup?.lookupData?.mvocInsightWave || []
  );
  const users = useSelector((state) => state?.product?.users);
  const [fetchMvocMetaData] = clarityNav.useGetMvocMetaDataMutation();
  const waveOptions = wave_lookup?.map((wave) => ({
    label: wave?.key,
    value: wave?.value,
  }));
  const [selectedUnifiedId, setSelectedUnifiedId] = useState(null);
  const [loaderStep, setLoaderStep] = useState(null);
  const [loaderMessage, setLoaderMessage] = useState("");

  const [selectedPromptId, setSelectedPromptId] = useState(null);
  const [selectedPrompt, setSelectedPrompt] = useState(null);
  const [currentPromptData, setCurrentPromptData] = useState(null);
  const refreshPrompts = useSelector((state) => state.ModalSlice.refreshPrompts);

  // Modify fetchPrompt to return the data
  const fetchPrompt = useCallback(async () => {
    try {
      const response = await projectPrompts({ project_id }).unwrap();

      if (!response?.result?.data || !Array.isArray(response?.result?.data)) {
        throw new Error("Invalid response format from API");
      }

      const promptLookupData = response.result.data.map(({ id, name, prompt_id }) => ({
        label: name,
        value: id,
        name: name,
        data: response?.result?.data?.find((prompt) => prompt?.id === id),
        openPrompt: openPrompt,
        id: id,
      }));
      
      // setSelectedPromptId(promptLookupData[0]?.value);
      setPromptLookup(promptLookupData);
      setIsPromptFetched(true);
      
      return promptLookupData; // Return the transformed data
    } catch (error) {
      console.error("Error fetching prompts:", error);
      return [];
    }
  }, [project_id]);

  // fetch MVOCMetaData and Active file data by project id
  const MvocMetaData = useCallback(async () => {
    const mvocMetaData = await fetchMvocMetaData(project_id);
    if (mvocMetaData?.data?.result) {
      const transformedData = transformMvocMetaData(
        mvocMetaData,
        wave_lookup,
        users,
        promptLookup
      );
      // Dispatch transformed data to Redux
      dispatch(setAttachmentRows(transformedData));
    }
  }, [project_id, isPromptFetched]);

  // // First fetch prompts, then metadata
  useEffect(() => {
    fetchPrompt();
  }, [fetchPrompt]);

  useEffect(() => {
    if (isPromptFetched) {
      MvocMetaData();
    }
  }, [fetchMvocMetaData, MvocMetaData, isPromptFetched]);

  // Update useEffect to listen for refreshPrompts
  useEffect(() => {
    if (refreshPrompts) {
      const refreshPromptData = async () => {
        const updatedPrompts = await fetchPrompt();
        setPromptLookup(updatedPrompts);
        // Reset the refresh flag
        dispatch(setRefreshPrompts(false));
      };
      
      refreshPromptData();
    }
  }, [refreshPrompts, fetchPrompt]);

  /// navidate to project
  useEffect(() => {
    // if (performance.getEntriesByType("navigation")[0]?.type === "reload") {
    //   const a = performance.getEntriesByType("navigation")
    //   // If page was refreshed, replace history to ensure back button works
    //   debugger
    //   window.history.replaceState(null, "", window.location.href);
    // } else {
    // Push a dummy state to prevent default back navigation
    window.history.pushState(null, "", window.location.href);
    // }

    const handleBackButton = () => {
      navigate("/", { replace: true }); // Redirect directly to Page 1
    };

    window.onpopstate = handleBackButton;

    return () => {
      window.onpopstate = null; // Cleanup on unmount
    };
  }, [navigate]);
  const [validationSchemav2, setValidationSchemav2] = useState(
    createValidationSchema(attachmentUUID)
  );

  // formik submit handler and for update project data and project count in redux (userProjectsData)
  const formik = useFormik({
    initialValues: {
      asset_name: "",
      indication_name: "",
      manufacturer_name: "",
      wave_name: {},
      prompt_name: {},
    },
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: false,
    validationSchema: validationSchemav2,
    onSubmit: async (values) => {
      try {
        if (AttachmentsRows?.length === 0 || (isAddFiles && selectedUnifiedId === null)) {
          setApiLoading(true);
          listenToServerEvents(userId, handleMessageReceived);

          try {
            const acknowledgePayload = { request_id: wave_unified_id };
            const ackResponse = await acknowledgeAPI({
              data: acknowledgePayload,
              project_id: project_id,
            }).unwrap();
          } catch (error) {
            console.log(error);
            setOopsLoader(true);
          }
        } else {
          try {
            dispatch(startLoading());
            const response = await fetchChatGptProcessService({
              selectedUnifiedId,
              project_id,
            }).unwrap();
            
            if (response?.result?.status === "SUCCESS" && response?.result) {
              dispatch(stopLoading());
              // Include selectedPromptId and selectedPrompt in navigation state
              navigate("/dashboard", { 
                state: {
                  ...response?.result,
                  selectedPromptId,
                  selectedPrompt
                }
              });
            } else {
              setOopsLoader(true);
            }
          } catch {
            setOopsLoader(true);
          }
        }
      } catch (error) {
        setOopsLoader(true);
        return;
      }
    },
  });

  // name check function
  const handleNameChek = async () => {
    formik.handleBlur({ target: { name: "name" } });
    if (project_id && formik.values.name === currentProjectDetails.name) {
      setProjectNameExistErrMsg("");
      return;
    }
    if (formik.values.name) {
      try {
        const payload = {
          name: formik.values.name,
        };
        const response = await nameValidation(payload);
        if (response.data.result) {
          setProjectNameExistErrMsg(response?.data?.message);
        } else {
          setProjectNameExistErrMsg("");
        }
      } catch (error) {}
    }
  };

  // on mount get MVOC details on the baios of project id from location
  useEffect(() => {
    const updateProjectDetails = async () => {
      if (project_id) {
        if (
          currentMVOCDetail &&
          Object?.keys(currentMVOCDetail)?.length > 0 &&
          currentMVOCDetail !== null
        ) {
          formik.setFieldValue(
            "asset_name",
            currentMVOCDetail.asset_name || ""
          );
          formik.setFieldValue(
            "indication_name",
            currentMVOCDetail.indication_name || ""
          );
          formik.setFieldValue(
            "manufacturer_name",
            currentMVOCDetail.manufacturer_name || ""
          );
          formik.setFieldValue("wave_name", currentMVOCDetail.wave_name || {});
          formik.setFieldValue(
            "prompt_name",
            currentMVOCDetail.prompt_name || {}
          );
        } else {
          try {
            if (stepper === 1) {
              return;
            }
            const mvocData = await fetchMvocDataById(project_id);
            console.log("2");
            if (mvocData?.isSuccess && mvocData?.data?.result) {
              formik?.setValues(mvocData?.data?.result);
              dispatch(setCurrentMVOCDetail(mvocData?.data?.result));
            }
          } catch (error) {}
        }
      }
    };
    updateProjectDetails();
  }, [useLocation().pathname, fetchMvocDataById]);

  // save wave and prompt name
  const saveWaveAndPromptNames = async () => {
    try {
      const wavePromptPayload = {
        wave: formik?.values?.wave_name?.value,
        prompt_id: formik?.values?.prompt_name?.value,
      };
      const response = await saveWaveAndPromptAPI({
        project_id: currentProjectDetails?.id,
        data: wavePromptPayload,
      }).unwrap();

      if (response?.success) {
        dispatch(setCurrentMVOCMetaData(response?.result));
        return response?.result;
      }
    } catch (error) {
      dispatch(
        openSnackbar({
          message: "Failed to save Wave and Prompt names.",
          type: SNACKBAR_TYPES.ERROR,
        })
      );
      setTimeout(() => {
        dispatch(closeSnackbar());
      }, 10000);
    }
  };

  useEffect(() => {
    if (eventResponse) {
      const fetchData = async () => {
        try {
          const response = await fetchChatGptProcessService({
            wave_unified_id,
            project_id,
          }).unwrap();
          if (response?.code && response?.result && eventResponse) {
            setaApiLoaderInfo(true);
            setApiLoading(false);
            
            // Create state object with response and prompt data
            const stateData = {
              ...response?.result,
              promptName: formik?.values?.prompt_name?.label,
              promptValue: formik?.values?.prompt_name?.value
            };

          

            navigate("/dashboard", { state: stateData });
          }
        } catch {
          setOopsLoader(true);
        }
      };
      fetchData();
    }
  }, [eventResponse]);

  const handleMessageReceived = (data) => {
    // setEventResponse(data?.result?.isGenAiResponseReceived);
    setLoaderMessage(data?.result?.message);
    setLoaderStep(data?.result?.loaderStep);

    if (data?.result?.status === "SUCCESS") {
      setEventResponse(data?.result?.isGenAiResponseReceived);
    } else if (data?.result?.status === "FAIL") {
      setOopsLoader(true);
    }
  };

 

  useEffect(() => {
    if (
      !formik.values.asset_name &&
      !formik.values.indication_name &&
      !formik.values.manufacturer_name &&
      !formik.values.wave_name &&
      !formik.values.prompt_name
    ) {
      // Only reset if values are not set
      formik.resetForm({
        values: formik.values, // Retains existing values
        errors: {}, // Clears errors
        touched: {}, // Resets touched fields
        validationSchema: createValidationSchema(attachmentUUID), // Ensure Formik uses new schema
      });
    } else {
      setValidationSchemav2(createValidationSchema(attachmentUUID));
    }
  }, [attachmentUUID]);

  // Add effect to watch formik values
  useEffect(() => {
    if (formik?.values?.asset_name !== undefined) {
      dispatch(updateFormValues({
        asset_name: formik.values.asset_name,
        indication_name: formik.values.indication_name
      }));
    }
  }, [formik?.values?.asset_name, formik?.values?.indication_name]);

  // Update handleNameChange to also update Redux
  const handleNameChange = (event, field) => {
    setProjectNameExistErrMsg("");
    formik.setFieldValue(field, event.target.value);
    
    // Update Redux if it's asset_name or indication_name
    if (field === 'asset_name' || field === 'indication_name') {
      dispatch(updateFormValues({
        [field]: event.target.value
      }));
    }
  };

  // Function to check if all required fields are filled
  const areAllFieldsFilled = () => {
    const {
      asset_name,
      indication_name,
      manufacturer_name,
      wave_name,
      prompt_name,
    } = formik.values;

    // Check if all required fields are filled and also check file conditions
    const fieldsFilled =
      asset_name.trim() !== "" &&
      indication_name.trim() !== "" &&
      manufacturer_name.trim() !== "" &&
      wave_name?.value !== undefined &&
      wave_name?.value !== "" &&
      prompt_name?.value !== undefined &&
      prompt_name?.value !== "";

    // If isActive, check if files are selected
    const filesFilled = isActive
      ? siMappingSelectedFile !== null &&
        siMappingSelectedFile !== undefined &&
        selectedFile !== null &&
        selectedFile !== undefined
      : selectedFile !== null && selectedFile !== undefined;
    // Return true only if both the fields and files conditions are met
    return fieldsFilled && filesFilled;
  };
  // Common MVOC file validation function
  const validateFile = (file) => {
    if (!file) {
      setFileError("File selection was canceled.");
      return;
    }

    if (!file.name.endsWith(".xlsx")) {
      setFileError("Please select a valid XLSX file.");
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      // Check if "conversation_column" is missing
      const headers = parsedData[0];
      if (!headers.includes("conversation_column")) {
        setFileError('The "conversation_column" is missing in the XLSX file');
        return;
      }

      // No errors, set the selected file
      setFileError("");
      // setSelectedFile(file);
    };

    reader.readAsArrayBuffer(file);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    validateFile(file);
    setSelectedFile(file);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  // Function to handle file drop and drag over events
  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    validateFile(file);
    setSelectedFile(file);
  };
  // common Si file validation
  const validateSiFile = (file) => {
    if (!file) {
      setSiMappingFileError("File selection was canceled.");
      return;
    }

    if (file && !file.name.endsWith(".xlsx")) {
      setSiMappingFileError("Please select a valid XLSX file");
      return;
    }
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      const headers = parsedData[0];
      const requiredColumns = ["Primary_Themes", "SI"];
      const hasAllColumns = requiredColumns.every((column) =>
        headers.includes(column)
      );

      if (!hasAllColumns) {
        setSiMappingFileError(
          "The required columns are missing in the XLSX file"
        );
        return;
      }

      // Proceed with upload logic if the required columns exist
      setSiMappingFileError("");
    };
    reader.readAsArrayBuffer(file);
    setSiMappingFileError("");
  };
  // function for upload file SI Mapping
  const handleSiMappingFileChange = (e) => {
    const file = e.target.files[0];
    validateSiFile(file);
    setSiMappingSelectedFile(file);
  };
  const handleSIDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    validateSiFile(file);
    setSiMappingSelectedFile(file);
  };
  const handleSIDragOver = (e) => {
    e.preventDefault();
  };

  const handleFileCancel = async () => {
    setSelectedFile(null);
    if (isFileUploadSuccessful && mvocFileId) {
        console.log("Cancelling file upload with ID:", mvocFileId);
        await cancleFileUpload({ file_id: mvocFileId, project_id });
    } else {
        console.log("mvocFileId is undefined or file upload was not successful.");
    }
    setIsFileUploadSuccessful(false);
    setWave_unified_id(null);
  };

  // Generalized function for chunked file upload
  const uploadFileChunks = async (file, fileType, wave_unified_id) => {
    if (!file) return false;

    const totalChunks = Math.ceil(file?.size / CHUNK_SIZE);
    const uniqueId = crypto.randomUUID();
    const fileId = `${uniqueId}-${file.name}`;
    let responses = [];

    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
      const start = chunkIndex * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, file.size);
      const chunk = file.slice(start, end);
      const formData = new FormData();
      formData.append("file", chunk);
      const uploadfilePayload = {
        unified_id: wave_unified_id,
        insight_type: INSIGHT_type?.MVOC,
        file_type: fileType,
      };
      const headerPayload = {
        file_size: file?.size,
        file_name: fileId,
        actual_file_name: file?.name,
        chunk_index: chunkIndex.toString(),
        total_chunks: totalChunks.toString(),
      };
      try {
        const data = await uploadFileServiceApi(
          {formData,
          body:uploadfilePayload,
          project_id,
          headers:headerPayload}
        ).unwrap();
        // Store API response details
        responses.push({
          chunkIndex,
          status: data?.status,
          message: data?.message || "Success",
          result: data?.result || null, // Store result from response
        });
        if (data?.status) {
          // If all chunks are uploaded successfully, set progress to 100%
          setProgress(100);
        }
      } catch (error) {
        // dispatch(openSnackbar({message: error,type: SNACKBAR_TYPES.ERROR,}))
        responses.push({
          chunkIndex,
          status: false,
          result: null,
        });
        setWave_unified_id(null);
        setRawErrorMessage(error?.response?.data?.message);
        setUploadedSuccess("fail");
        return { success: false, responses };
      }
    }

    return { success: true, responses };
  };

  const commonUploading = async (wave_unified_id) => {
    const allFieldsFilled = areAllFieldsFilled();
    if (!allFieldsFilled) {
      // Show toast message about missing input fields
      dispatch(
        openSnackbar({
          message: "Please fill all required fields.",
          type: SNACKBAR_TYPES.ERROR,
        })
      );
      setTimeout(() => {
        dispatch(closeSnackbar());
      }, 10000);
      return;
    }

    // Check file upload conditions
    if (!selectedFile || (isActive && !siMappingSelectedFile)) {
      dispatch(
        openSnackbar({
          message: "Please Upload MVOC and SI files.",
          type: SNACKBAR_TYPES.ERROR,
        })
      );
      setTimeout(() => {
        dispatch(closeSnackbar());
      }, 10000);
      return;
    }
    // Open modal to show upload progress
    setopenModal(true);
    let selectedFileSuccess = false;
    if (selectedFile) {
      const mvocResponse = await uploadFileChunks(
        selectedFile,
        "MVOC",
        wave_unified_id
      );
      if (mvocResponse?.success) {
        selectedFileSuccess = true; // Only set true if success
        setMvocFileId(mvocResponse?.responses[0]?.result?.id);
        console.log("File uploaded successfully, mvocFileId set to:", mvocFileId);
      }

      console.log(mvocResponse);
    }
    // Upload siMappingSelectedFile if isActive is true
    let siMappingFileSuccess = false;
    if (isActive && siMappingSelectedFile) {
      const siMappingResponse = await uploadFileChunks(
        siMappingSelectedFile,
        "SI_MAPPING",
        wave_unified_id
      );
      if (siMappingResponse?.success) {
        siMappingFileSuccess = true; // Only set true if success
        setSiMappingFileId(siMappingResponse?.responses[0]?.result?.id);
      }
      // setSiMappingFileId(siMappingFileSuccess?.result?.id)
    }
    // Determine overall success
    if (selectedFileSuccess && (!isActive || siMappingFileSuccess)) {
      setUploadedSuccess("success");
      setIsFileUploadSuccessful(true);
      setIsFileSiUpload(true);
      dispatch(
        openSnackbar({
          message: "File uploaded successfully",
          type: SNACKBAR_TYPES.SUCCESS,
        })
      );
      setTimeout(() => {
        dispatch(closeSnackbar());
      }, 10000);
    } else {
      setUploadedSuccess("fail");
      setIsFileUploadSuccessful(false);
      setIsFileSiUpload(false);
    }
  };

  // upload file
  const handleUpload = async (e) => {
    e.preventDefault();
    const errors = await formik.validateForm();
    // If there are errors, mark all fields as touched to show error messages
    formik.setTouched({
      asset_name: true,
      indication_name: true,
      manufacturer_name: true,
      wave_name: true,
      prompt_name: true,
    });
    if (Object.keys(errors).length > 0) {
      return; // Stop execution if there are validation errors
    }
    const allFieldsFilled = areAllFieldsFilled();
    if (!allFieldsFilled) {
      // Show toast message about missing input fields
      const showSnackbarError = (message) => {
        dispatch(
          openSnackbar({
            message,
            type: SNACKBAR_TYPES.ERROR,
          })
        );
        setTimeout(() => dispatch(closeSnackbar()), 10000);
      };
      if (isActive && !siMappingSelectedFile && !selectedFile) {
        showSnackbarError("Please Upload MVOC and SI files.");
        return;
      }
      if (isActive && !siMappingSelectedFile) {
        showSnackbarError("Please Upload SI files.");
        return;
      }

      if (!selectedFile) {
        showSnackbarError("Please Upload MVOC files.");
        return;
      }
    }

    try {
      // Check if currentMVOCDetail is present in Redux
      if (currentMVOCDetail && Object.keys(currentMVOCDetail).length > 0) {
        if (formik?.values?.wave_name && formik?.values?.prompt_name) {
          const waveSaveResponse = await saveWaveAndPromptNames();
          setWave_unified_id(waveSaveResponse?.unified_id);

          // Check if waveSaveResponse is not empty or null, and then call commonUploading
          if (waveSaveResponse && Object.keys(waveSaveResponse).length > 0) {
            await commonUploading(waveSaveResponse?.unified_id);
          }
        } else {
          dispatch(
            openSnackbar({
              message: ERROR_MESSAGES.MVOC_METADATA_ERROR,
              type: SNACKBAR_TYPES.ERROR,
            })
          );
        }
        return; // Exit the function to prevent further execution
      }

      const payload = {
        asset_name: formik?.values.asset_name,
        indication_name: formik?.values.indication_name,
        manufacturer_name: formik?.values.manufacturer_name,
      };
      // Step 1: Save MVOC data
      const response = await createMVOC({
        project_id: currentProjectDetails?.id,
        data: payload,
      }).unwrap();

      console.log(response, "res==>");
      if (response?.success) {
        // Step 2: Save Wave and Prompt names
        const waveSaveResponse = await saveWaveAndPromptNames();
        setWave_unified_id(waveSaveResponse?.unified_id);
        if (checkDataisObject(response?.result)) {
          setDisableInput(true);
          const MVOCData = {
            project_id: currentProjectDetails?.id,
            asset_name: formik?.values?.asset_name,
            indication_name: formik?.values?.indication_name,
            manufacturer_name: formik?.values?.manufacturer_name,
            wave_name: formik?.values?.wave_name,
            prompt_name: formik?.values.prompt_name,
          };
          dispatch(setCurrentMVOCDetail(MVOCData));
          dispatch(setStepcompleted(3));
        } else {
        }
        console.log(saveWaveAndPromptNames);
        if (waveSaveResponse && Object.keys(waveSaveResponse).length > 0) {
          await commonUploading(waveSaveResponse?.unified_id);
        }
      } else {
      }
    } catch (error) {
      console.log(error, "error");
      dispatch(
        openSnackbar({
          message: error?.data?.errorMessage,
          type: SNACKBAR_TYPES.ERROR,
        })
      );
    }
  };

  const handleSiMappingFileCancel = async () => {
    setSiMappingSelectedFile(null);
    if (isFileSiUpload && siMappingFileId) {
      console.log(siMappingFileId,"siMappingFileIdsiMappingFileId")
      await cancleFileUpload({file_id:siMappingFileId,project_id});
    }
    setIsFileSiUpload(false);
    // setWave_unified_id(null);
  };

  // function for toggle button activation
  const toggle = async () => {
    if (isActive && selectedFile) {
      setIsFileUploadSuccessful(true);
      setIsFileSiUpload(true);
    }
    if (isActive && isFileSiUpload && siMappingFileId) {
      await cancleFileUpload({file_id:siMappingFileId,project_id});
    }
    // When toggling to active, clear the error
    if (!isActive) {
      setSiMappingFileError(null);
    }
    setIsActive(!isActive);
  };

  // Update the handler to receive prompt_id
  const handleAttachmentUUIDChange = (id, unified_id, prompt_id,prompt) => {
    setSelectedUnifiedId(unified_id);
    setAttachmentUUID(id);
    // Set the prompt ID for the modal
    setSelectedPromptId(prompt_id);
    setSelectedPrompt(prompt)
  };

  const handleCloseIconClick = () => {
    setIsAddFiles(false);
    formik.setErrors({});
    formik.setTouched({});
  };

  // Function to open the prompt modal
  const openPrompt = (id) => {
    dispatch(openPromptModal({ id: id, promptData: id?.data }));
    setSelectedPromptId(id?.prompt_id);
    setCurrentPromptData(id?.data)
  };
  // console.log(currentPromptData)


  // Move handleButtonClick outside of any effects or other handlers
  const handleButtonClick = useCallback(() => {
    // Force state update regardless of dropdown values
    setIsAddFiles(true);
    setSelectedUnifiedId(null);
    setAttachmentUUID(null);
  }, []); // Keep dependencies empty to ensure consistent behavior



  // Modify how the AddFile component is rendered
  const renderAddFile = useMemo(() => {
    if (AttachmentsRows?.length > 0) {
      return (
        <AddFile
          isAddFiles={isAddFiles}
          onAddFile={handleButtonClick} // Pass the handler directly
          onAttachmentUUIDChange={handleAttachmentUUIDChange}
          setAttachmentUUID={setAttachmentUUID}
        />
      );
    }
    return null;
  }, [AttachmentsRows?.length, isAddFiles, handleButtonClick]);

  return (
    <div>
      <div className="container-fluid pt-3">
        <div className="card MVOC-card w-100 border-none">
          <form onSubmit={formik.handleSubmit}>
            <span className="project-title-text">
              {createProjectHeading.MVOC_INSIGHT}
            </span>
            {/* up details */}
            <div className="w-[100%] flex gap-[20px]" key={1}>
              {upFields.map((field) => (
                <div className="mb-[20px] w-[50%]" key={field.id}>
                  <p className="font-semibold text-sm text-primaryBlack mb-2">
                    {field.label}
                    {field.isMandatory && (
                      <span className="text-red-500 pl-[2px]">*</span>
                    )}
                    {field.otherLabel && (
                      <span className="pl-[2px] text-sm font-medium text-optionalTextColor ">
                        ({field.otherLabel})
                      </span>
                    )}
                  </p>
                  {field?.type == "input" && (
                    <InputLayout
                      placeholder={field?.placeholder}
                      className="text-[#25282B] focus-visible:outline-none border border-formInputBorder rounded-md w-[100%] font-normal text-sm pl-1 pt-2.5 pb-2.5"
                      id={field.id}
                      onChange={
                        field?.id == "name"
                          ? (e) => handleNameChange(e, field?.id)
                          : formik.handleChange
                      }
                      value={formik?.values[field?.id] || ""}
                      disable={disableMVOC || disableInput}
                    />
                  )}
                  {field.type == "dropdown" && (
                    <SelectDropdown
                      options={field?.options}
                      value={formik?.values[field?.id]}
                      onChange={(e) => console.log(e)}
                      onBlur={formik?.handleBlur}
                      name={field?.id}
                      placeholder={field?.placeholder}
                      isMulti={field?.isMulti}
                      isDisabled={field?.isDisabled}
                    />
                  )}
                  {formik.touched[field.id] && formik.errors[field.id] && (
                    <div className="flex items-center mt-2">
                      <p className="pl-1 text-xs font-semibold text-errorMessageColor">
                        {formik.errors[field.id]}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
            {/* down details */}
            <div className="w-[100%] flex gap-[20px]" key={1}>
              {downFields.map((field) => (
                <div className="mb-[20px] w-[100%]" key={field.id}>
                  <p className="font-semibold text-sm text-primaryBlack mb-2">
                    {field.label}
                    {field.isMandatory && (
                      <span className="text-red-500 pl-[2px]">*</span>
                    )}
                    {field.otherLabel && (
                      <span className="pl-[2px] text-sm font-medium text-optionalTextColor ">
                        ({field.otherLabel})
                      </span>
                    )}
                  </p>
                  {field.type == "input" && (
                    <InputLayout
                      placeholder={field.placeholder}
                      onBlur={
                        field.id == "name" ? handleNameChek : formik.handleBlur
                      }
                      className="text-primaryGray focus-visible:outline-none border border-formInputBorder rounded-md w-[100%] h-16 font-normal text-sm pl-1 pt-2.5 pb-2.5"
                      id={field.id}
                      onChange={
                        field.id == "name"
                          ? (e) => handleNameChange(e, field.id)
                          : formik.handleChange
                      }
                      value={formik?.values[field?.id] || ""}
                      disable={disableMVOC}
                    />
                  )}
                  {field.type == "dropdown" && (
                    <SelectDropdown
                      options={
                        field.id === "wave_name"
                          ? waveOptions
                          : field.id === "prompt_name"
                          ? promptLookup
                          : field?.options
                      }
                      value={formik?.values?.[field?.id]}
                      onChange={(e) => formik.setFieldValue(field?.id, e)}
                      onBlur={formik.handleBlur}
                      name={field?.id}
                      placeholder={field?.placeholder}
                      isMulti={field?.isMulti}
                      isDisabled={field?.isDisabled}
                      isPromptName={field?.id === "prompt_name"}
                      openPrompt={openPrompt}
                    />
                  )}
                  {formik.touched[field.id] && formik.errors[field.id] && (
                    <div className="flex items-center mt-2">
                      <p className="pl-1 text-xs font-semibold text-errorMessageColor">
                        {formik.errors[field.id]}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </form>

          {/* ****Upload Voice of Customer(MVOC) data file Upload the themes to Strategic Imperatives(SI) Mapping****** */}
          {(AttachmentsRows?.length == 0 ||
            (AttachmentsRows?.length > 0 && isAddFiles)) && (
            <>
              <div className="d-flex w-100 mb-[9px]">
                <div className="mvoc-drop-down-wd">
                  <div className="d-flex align-items-center position-relative hgt-30p pb-[9px]">
                    <p className="font-semibold text-sm text-primaryBlack">
                      {uploadfileComponentDetails.MVOCDATAFILE}
                    </p>
                  </div>
                  <div
                    className={`drop-zone drop-zone-section ${
                      fileError ? "error" : ""
                    }`}
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                  >
                    {!hideDragDropOfMvoc && (
                      <img src={UploadIcon} alt="Upload Icon" />
                    )}
                    <div className="d-flex align-items-center w-full">
                      <label className="custom-file-upload w-full">
                        <div className="text-center">
                          {!selectedFile && (
                            <div className="d-flex align-items-center justify-content-center mb-3">
                              <p className="browser-text">Click to upload</p>
                              <p className="your-file-text">or Drag and Drop</p>
                            </div>
                          )}
                          <p className="upload-text-small">
                            {uploadfileComponentDetails.MVOCFILEFORMATE}
                          </p>
                        </div>
                        {selectedFile && (
                          <div className="d-flex flex-column align-items-center mt-[42px]">
                            <div className="selected-file-name position-relative d-flex align-items-center mt-2 w-full">
                              <div>
                                <img src={fileicon} alt="Upload Icon" />
                              </div>{" "}
                              {selectedFile && selectedFile.name}
                              <div
                                className="ms-auto"
                                onClick={handleFileCancel}
                                style={{ cursor: "pointer" }}
                              >
                                <img src={closeicon} alt="Close Icon" />
                              </div>
                            </div>
                          </div>
                        )}
                        <input
                          type="file"
                          accept=".xlsx"
                          onChange={handleFileChange}
                          onBlur={handleFileCancel}
                        />
                      </label>
                    </div>
                    {fileError && <p className="error-message">{fileError}</p>}
                  </div>
                </div>
                {/* second file */}
                <div className="si-mapping-drop-down-wd pr-0">
                  <div className="d-flex align-items-center position-relative hgt-30p pb-[9px]">
                    <p className="font-semibold text-sm text-primaryBlack mr-[10px]">
                      {uploadfileComponentDetails.SIMAPPINGFILE}
                    </p>
                    <button
                      className={`pl-0.5 ${
                        isActive
                          ? "on toggle-button position-relative"
                          : "off toggle-button"
                      }`}
                      onClick={toggle}
                    >
                      <span className="toggle-yes">
                        {isActive ? "Yes" : ""}
                      </span>
                      <span className="pin" />
                      <span className="toggle-no">{isActive ? "" : "No"}</span>
                    </button>
                    {/* close icon */}
                    {AttachmentsRows?.length > 0 && (
                      <div
                        className="ml-auto"
                        onClick={handleCloseIconClick}
                        style={{ cursor: "pointer" }}
                      >
                        <img src={closeicon} alt="" />
                      </div>
                    )}
                  </div>

                  <div
                    className={`drop-zone drop-zone-section ${
                      siMappingFileError ? "error" : ""
                    } ${isActive ? "" : "disabled"}`}
                    onDragOver={handleSIDragOver}
                    onDrop={handleSIDrop}
                  >
                    {!hideDragDropOfSi && (
                      <img src={UploadIcon} alt="Upload Icon" />
                    )}
                    <div className="d-flex align-items-center w-full">
                      <label className="custom-file-upload w-full">
                        <div className="text-center">
                          {!siMappingSelectedFile && (
                            <div className="d-flex align-items justify-content-center center mb-3">
                              <>
                                {isActive ? (
                                  <>
                                    <p className="browser-text">
                                      Click to upload
                                    </p>
                                    <p className="your-file-text">
                                      or Drag and Drop
                                    </p>
                                  </>
                                ) : (
                                  <>
                                    <p className="browser-text">
                                      Click to upload
                                    </p>
                                    <p className="your-file-text">
                                      or Drag and Drop
                                    </p>
                                  </>
                                )}
                              </>
                            </div>
                          )}
                          <p className="upload-text-small">
                            {uploadfileComponentDetails.SIMAPPINGFILEFORMATE}
                          </p>
                          <div className="d-flex align-items-center justify-content-center center mb-3 gap-1.5">
                            <img src={Ristricticon} alt="Ristrict Icon" />
                            <p className="upload-text-extra-small">
                              {uploadfileComponentDetails.SIRESTRICITION}
                            </p>
                          </div>
                        </div>
                        {siMappingSelectedFile && (
                          <div className="d-flex flex-column align-items-center">
                            <div className="selected-file-name position-relative d-flex align-items-center mt-2 w-full">
                              <div>
                                <img src={fileicon} alt="Upload Icon" />
                              </div>{" "}
                              {siMappingSelectedFile &&
                                siMappingSelectedFile.name}
                              {/* </p> */}
                              <div
                                className="ms-auto"
                                onClick={handleSiMappingFileCancel}
                                style={{ cursor: "pointer" }}
                              >
                                <img src={closeicon} alt="Close Icon" />
                              </div>
                            </div>
                          </div>
                        )}
                        {isActive ? (
                          <input
                            type="file"
                            accept=".xlsx"
                            onChange={handleSiMappingFileChange}
                            onBlur={handleSiMappingFileCancel}
                          />
                        ) : (
                          ""
                        )}
                      </label>
                    </div>
                    {/* {siMappingFileError && (
                      <p className="error-message">{siMappingFileError}</p>
                    )} */}
                    {siMappingFileError && isActive && (
                      <p className="error-message">{siMappingFileError}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="download-sample-data-main">
                <div className="download-sample-data-mvoc">
                  <p className="download-sample-data">
                    <a
                      href={MvocSampleFile}
                      download="Sample-MVOC"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={Downloadicon} alt="Download Icon" />
                      Download Sample file
                    </a>{" "}
                  </p>
                </div>
                <div className="download-upload-btn">
                  <div className="download-sample-data-si">
                    <p
                      className={
                        isActive
                          ? "download-sample-data"
                          : "download-sample-data disabled"
                      }
                    >
                      {isActive ? (
                        <>
                          <a
                            href={SiMappingSampleFile}
                            download="Sample-SI-Mapping"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img src={Downloadicon} alt="Download Icon" />
                            Download Sample file
                          </a>{" "}
                        </>
                      ) : (
                        <>
                          <a
                            href={SiMappingSampleFile}
                            download="Sample-SI-Mapping"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img src={Downloadicon} alt="Download Icon" />
                            Download Sample file
                          </a>{" "}
                        </>
                      )}
                    </p>
                  </div>
                  <div className="upload-btn-common">
                    <ButtonComponent
                      variant="contained"
                      onClick={handleUpload}
                      btnType="primary"
                      text="Upload"
                      className="btn btn-sm btn-upload-file"
                    />
                  </div>
                </div>
              </div>
            </>
          )}
          {/* ************ */}
          {renderAddFile}
        </div>
        {(stepper === 2 || projectexist) && (
          <div className="d-flex w-100 mt-[20px] pb-[20px] justify-content-end">
            <ButtonComponent
              variant="contained"
              onClick={formik.handleSubmit}
              btnType="primary"
              text="Save & Next"
              className="btnPrimary"
              disabled={
                !(attachmentUUID || (isFileUploadSuccessful && isFileSiUpload))
              }
            />
          </div>
        )}
        {apiLoading && (
          <ApiLoader
            loaderMessage={loaderMessage}
            loaderStep={loaderStep}
            apiLoaderInfo={apiLoaderInfo}
            oopsLoaderInfo={oopsLoader}
            setOopsLoader={setOopsLoader}
          />
        )}
      </div>
      <FileUploadModal
        selectedFile={selectedFile}
        siMappingSelectedFile={siMappingSelectedFile}
        openModal={openModal}
        setopenModal={setopenModal}
        progress={progress}
        setProgress={setProgress}
        upladedSuccess={upladedSuccess}
        setUploadedSuccess={setUploadedSuccess}
        duplicateErrorMessage={duplicateErrorMessage}
        setDuplicateErrorMessage={setDuplicateErrorMessage}
        rawErrorMessage={rawErrorMessage}
        setRawErrorMessage={setRawErrorMessage}
        dataErrorMessage={dataErrorMessage}
        setDataErrorMessage={setDataErrorMessage}
        isActive={isActive}
        setSelectedFile={setSelectedFile}
        setSiMappingSelectedFile={setSiMappingSelectedFile}
        setIsFileUploadSuccessful={setIsFileUploadSuccessful}
      />
      <PromptModal promptId={selectedPromptId} promptData={currentPromptData} />
    </div>
  );
}

export default MVOC;
